import Storage from '../storage';
import { version } from '../util/version';
export default class MetadataManager {
  constructor(pollingConfig) {
    this.pollingSeconds = pollingConfig.interval / 1000;
  }
  updateClientCauseReason(reason) {
    this.clientCauseReason = reason;
  }
  updateClientUserState(state) {
    this.clientUserState = state;
  }
  get() {
    const metadata = {
      client: {
        name: 'feature-flag-web-client',
        version
      },
      config: {
        pollingSeconds: this.pollingSeconds
      },
      state: {
        // Need to cast VisibilityState (type) to ClientVisibilityState (enum)
        visibility: document.visibilityState,
        storage: Storage.getStorageStatus(),
        userContext: this.clientUserState,
        cause: this.clientCauseReason
      }
    };
    return metadata;
  }
}